import union from 'lodash/union';
import difference from 'lodash/difference';

const defaultState = {
  session_proxy: {},
  all_session_ids: [],
};

export default ActionTypes => {
  return (state = defaultState, action) => {
    try {
      switch (action.type) {
        case ActionTypes.SESSION_PROXY: {
          const { addedSessions, removedSessionIds } = action.payload;
          const sessionProxy = { ...state.session_proxy };

          if (addedSessions) {
            addedSessions.forEach(session => {
              sessionProxy[session.id] = session;
            });
          }

          if (removedSessionIds) {
            removedSessionIds.forEach(id => {
              delete sessionProxy[id];
            });
          }
          return {
            ...state,
            session_proxy: sessionProxy,
          };
        }
        case ActionTypes.ADD_TO_ALL_SESSIONS:
          return {
            ...state,
            all_session_ids: union(state.all_session_ids, action.payload),
          };

        case ActionTypes.REMOVE_FROM_ALL_SESSIONS:
          return {
            ...state,
            all_session_ids: difference(state.all_session_ids, action.payload),
          };

        case ActionTypes.CLEAR_ALL_SESSIONS:
          return {
            ...state,
            all_session_ids: [],
          };

        case ActionTypes.CURRENT_SESSION_META_PROXY:
          return {
            ...state,
            current_session_meta_proxy: action.payload.sessionId,
            currentOwnerGuid: action.payload.ownerGuid,
          };

        default:
          return state;
      }
    } catch (error) {
      console.error(
        `Error in sessions reducer: ${error.message || error.code || error}`,
        error
      );
    }
    return state;
  };
};



// WEBPACK FOOTER //
// ./src/reducers/restricted/_session.js